import {
  FETCH_RESPONSES_REQUEST,
  FETCH_RESPONSES_SUCCESS,
  FETCH_RESPONSES_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  responses: [],
  error: null,
};

const ListReponsesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RESPONSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_RESPONSES_SUCCESS:
      return {
        ...state,
        loading: false,
        responses: action.payload,
      };
    case FETCH_RESPONSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        responses: [],
      };
    default:
      return state;
  }
};

export default ListReponsesReducer;
